/**
 * 2020-12-20
 * handan
 * 生成灰度
 */

import WebStorageCache from "web-storage-cache";
import API from "../API";

const wsCache = new WebStorageCache()
/**
 * 
 * @param {number} gray 0 - 1 的数字，0.2表示灰度20% 
 */
const getGray = (gray) => {
  let useTimeIsGray = wsCache.get("useTimeIsGray") ;
  if(useTimeIsGray !== null && useTimeIsGray !== "null") return useTimeIsGray ;
  // 产生一个0-9的数组，从日期末尾数字开始
  let dd = new Date().getDate() % 10;
  let randomArr = [] ;
  for(let i = 0; i < gray * 10; i++){
    if(dd < 10){
      randomArr.push(dd)
      dd++ ;
    }else{
      dd = 0 ;
      randomArr.push(dd)
      dd++ ;
    }
  }
  // 去一个随机数，看是否落在了产生的数组里面
  let randomNum = Math.floor(Math.random() * 10) ;
  if(randomArr.indexOf(randomNum) !== -1){
    useTimeIsGray = true ;
  } else {
    useTimeIsGray = false ;
  }
  // 过期时间设置为每天的凌晨
  let expTime = new Date(new Date(new Date().toLocaleDateString()).getTime()+24*60*60*1000) ;
  wsCache.set("useTimeIsGray", useTimeIsGray, { exp: expTime })
  return useTimeIsGray ;
}

export default getGray ;